// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.group-filter-contacts-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin: 20px auto; 
  gap: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .group-input-filed {
    display: flex;
    flex-direction: column;
    width: 30%;
  }
  
  .group-input-filed label {
    font-weight: bold;
    margin-bottom: 8px;
    text-align: left;
  }

  .group-input-filed select {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
    border-radius: 4px;
    width: 100%; 
    box-sizing: border-box;
    margin-bottom: 10px;
  }
  
  .group-input-filed input {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
    background: #fff;
    border-radius: 4px;
    width: 100%; 
    box-sizing: border-box;
    /* margin-bottom: 10px; */
    color: #373737;
  }
  

  .group-form-actions {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 15px 0 0;
  }
  
  .group-form-actions .btn {
    padding: 8px 16px;
    font-size: 16px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .group-form-actions .submit-btn {
    background-color: #44a67e;
    border-color: #44a67e;
  }
  
  .group-form-actions .submit-btn:hover {
    background-color: #44a67e;
    border-color: #44a67e;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }
  
  .group-form-actions .cancel-btn {
    background-color: #fb3d4e;
  }
  
  .group-form-actions .cancel-btn:hover {
    background-color: #c82333;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }

  /* Response Message */
  .shortUrlResponse {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
    margin: 10px auto;
  }

  .shortUrlResponse p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
  }
  
  
  /* search filter */
  .group-contact-search-filter {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    align-items: center;
    gap: 20px;
  }
  
  .group-contact-search-filter input {
    width: 250px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }

  .individual-contacts-table .delete-btn {
    background-color: #fb3d4e;
    color: #fff;
    border: 1px solid #fb3d4e;
  }
  
  /* ==========Message Note Style=========  */
  .group-input-filed .input-alert-combine {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
  .group-input-filed small {
    /* color: #373435;
    font-size: 12px;
    text-align: start; */
    font-size: 13px !important;
    font-style: italic;
    color: #44a67e;
    text-align: start;
    font-weight: 550;
  }

  .wrap-group-contacts {
    margin: 0 40px;
  }`, "",{"version":3,"sources":["webpack://./src/components/GroupContacts/GroupContacts.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;EAChB;;;EAGA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,qFAAqF;EACvF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,qFAAqF;EACvF;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;;EAGA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,yBAAyB;EAC3B;;EAEA,2CAA2C;EAC3C;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE;;wBAEoB;IACpB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB","sourcesContent":["\r\n.group-filter-contacts-wrap {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 25px 20px;\r\n  margin: 20px auto; \r\n  gap: 20px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px; \r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .group-input-filed {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 30%;\r\n  }\r\n  \r\n  .group-input-filed label {\r\n    font-weight: bold;\r\n    margin-bottom: 8px;\r\n    text-align: left;\r\n  }\r\n\r\n  .group-input-filed select {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n    border-radius: 4px;\r\n    width: 100%; \r\n    box-sizing: border-box;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .group-input-filed input {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n    background: #fff;\r\n    border-radius: 4px;\r\n    width: 100%; \r\n    box-sizing: border-box;\r\n    /* margin-bottom: 10px; */\r\n    color: #373737;\r\n  }\r\n  \r\n\r\n  .group-form-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    padding: 15px 0 0;\r\n  }\r\n  \r\n  .group-form-actions .btn {\r\n    padding: 8px 16px;\r\n    font-size: 16px;\r\n    color: #fff;\r\n    background-color: #007bff;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .group-form-actions .submit-btn {\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n  }\r\n  \r\n  .group-form-actions .submit-btn:hover {\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n  \r\n  .group-form-actions .cancel-btn {\r\n    background-color: #fb3d4e;\r\n  }\r\n  \r\n  .group-form-actions .cancel-btn:hover {\r\n    background-color: #c82333;\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n  /* Response Message */\r\n  .shortUrlResponse {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    margin: 10px auto;\r\n  }\r\n\r\n  .shortUrlResponse p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n  \r\n  \r\n  /* search filter */\r\n  .group-contact-search-filter {\r\n    margin: 20px auto;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: end;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .group-contact-search-filter input {\r\n    width: 250px;\r\n    padding: 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .individual-contacts-table .delete-btn {\r\n    background-color: #fb3d4e;\r\n    color: #fff;\r\n    border: 1px solid #fb3d4e;\r\n  }\r\n  \r\n  /* ==========Message Note Style=========  */\r\n  .group-input-filed .input-alert-combine {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n  \r\n  .group-input-filed small {\r\n    /* color: #373435;\r\n    font-size: 12px;\r\n    text-align: start; */\r\n    font-size: 13px !important;\r\n    font-style: italic;\r\n    color: #44a67e;\r\n    text-align: start;\r\n    font-weight: 550;\r\n  }\r\n\r\n  .wrap-group-contacts {\r\n    margin: 0 40px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
